import { SetStateAction, useEffect, useState } from "react";
import axios from "axios";
import { useParams, useLocation } from "react-router-dom";
import AfficheProduitClient from "../../../Views/Utilisateure/client/AfficheProduitClient";

interface Product {
  id: string;
  name: string;
  imageUrl: string;
  price: string;
  quantity: number;
}

export default function AfficheProduitClientService() {
  const { id, articleId } = useParams(); 
  const location = useLocation();
  const articleState = location.state?.article;

  const [loading, setLoading] = useState<boolean>(true);
  const [article, setArticle] = useState<any>(null);

  useEffect(() => {
    if (articleState) {
      setArticle(articleState);
      setLoading(false);
      return;
    }

    // Fallback: we lost state. We need ClientId to fetch.
    const clientId = id || localStorage.getItem("ClientId");
    if (!clientId) {
      setLoading(false);
      return;
    }

    const fetchProduct = async () => {
      try {
        const { data } = await axios.get(`${process.env.REACT_APP_PHP_APP_URL}/client/${clientId}/articles`);
        if (Array.isArray(data)) {
          const found = data.find((a: any) => String(a.IdArticle || a.id) === String(articleId));
          if (found) setArticle(found);
        }
      } catch (err) {
        console.error("Error fetching article list:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchProduct();
  }, [articleState, id, articleId]);

  if (loading) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#FAFAFA' }}>
        <div style={{ width: '40px', height: '40px', border: '4px solid #f3f3f3', borderTop: '4px solid #F5A623', borderRadius: '50%', animation: 'spin 1s linear infinite' }}></div>
        <span style={{ marginTop: '16px', color: '#64748B', fontWeight: 600, fontFamily: 'Inter, sans-serif' }}>Chargement des informations...</span>
        <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  if (!article) {
    return <div style={{textAlign: 'center', marginTop: '100px', fontSize: '18px', fontWeight: 'bold'}}>Article introuvable.</div>;
  }

  return (
    <>
      <AfficheProduitClient
        Remise={article.Remise || ""}
        IdArticle={article.IdArticle || article.id || 0}
        Designation={article.Designation || "Inconnu"}
        PrixVenteArticleTTC={article.PrixVenteArticleTTC || article.PrixNetHT || article.PrixTtc || "0"}
        PrixNetHT={article.PrixNetHT || article.PrixVenteArticleTTC || article.PrixTtc || "0"}
        LibelleSubstitut={article.LibelleSubstitut || article.Libellsubstitut || ""}
        RefArticle={article.RefArticle || ""}
        urlImage={article.urlImage || article.image || article.imageUrl || article.Image || ""}
        image={article.urlImage || article.image || article.imageUrl || article.Image || ""}
        Description={article.Description || ""}
        quantité={article.quantité || article.Qte || article.Quantite || 0}
        stock={article.quantité || article.Qte || article.Quantite || article.stock || 0}
        prix_ht_2_magasin={article.Prix2 || article.prix_ht_2_magasin || ""}
        prix_ht_3_magasin={article.Prix3 || article.prix_ht_3_magasin || ""}
        prix_ht_1_magasin={article.Prix1 || article.prix_ht_1_magasin || ""}
        NomMagasin={article.NomMagasin || ""}
        Unite={article.Unite || ""} 
        setDesignation={() => {}} 
        setPrixVenteArticleTTC={() => {}} 
        setDescription={() => {}} 
        setImage={() => {}} 
        setstock={() => {}} 
        setRefARticle={() => {}} 
        setUnite={() => {}} 
        setQuantité={() => {}} 
        setprix_ht_2_magasin={() => {}} 
        setprix_ht_3_magasin={() => {}} 
        setprix_ht_1_magasin={() => {}} 
        setquantité={() => {}} 
        setNomClient={() => {}} 
        setAdresse={() => {}} 
        setTotalCommandeHT={() => {}} 
        setTotalRemise={() => {}} 
      />
    </>
  );
}